import { useParams } from 'react-router-dom';

import { useCreditCardDetails } from '@/components/modules/_shared/hooks/useCreditCard';
import { CreditCardIncome } from '@/components/modules/CreditCard/Detail/OnboardingDetails/components/BankAccount/components/CreditCardIncome';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { SubSectionWrapper } from '@/components/shared/components/SubSectionWrapper';
import { PendingDataType } from '@/config/types';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

export const CreditCardPersonalFinance = () => {
  const { creditCardId } = useParams();

  if (!creditCardId) return null;

  const { creditCardDetails } = useCreditCardDetails({ creditCardId });

  if (!creditCardDetails || !creditCardDetails.accountNumber || !creditCardDetails.configuration.holderName) {
    return (
      <SubSectionWrapper title="BANK_ACCOUNT_DATA">
        <PendingDataWarning type={PendingDataType.DEFAULT} />
      </SubSectionWrapper>
    );
  }

  return (
    <SubSectionWrapper title="BANK_ACCOUNT_DATA">
      <CreditCardIncome
        accountNumber={creditCardDetails.accountNumber}
        holderName={creditCardDetails.configuration.holderName}
      />
    </SubSectionWrapper>
  );
};

export const CreditCardPersonalFinanceModule = withPermissionsModule(CreditCardPersonalFinance);
